import { useFlyOutProductsBasedOnSelectedCloud } from '../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import { MainTabsV2 } from '@labrav/react-components'

import { useStyles } from './PrivateOfferResaleAuthorizationTabs.styles'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { settingsTabs } from '../../components/FlyOutOnboardingWrapper/settingsTabs'
import { Product } from '../../modules/productsListing/types'
import clsx from 'clsx'
import { isEmpty } from 'lodash'
import { isResaleProduct } from '../../utils/privateOfferOrResaleHelperFunctions'

type PrivateOfferResaleAuthorizationTabsProps = {
  subUrl: string
  privateOfferComp: JSX.Element
  resaleOfferComp?: JSX.Element
  search?: string
  isExternal?: boolean
  tableEl?: React.RefObject<HTMLDivElement>
}

const PrivateOfferResaleAuthorizationTabs = (
  privateOfferResaleAuthorizationTabsProps: PrivateOfferResaleAuthorizationTabsProps
) => {
  const { classes } = useStyles({
    isExternal: privateOfferResaleAuthorizationTabsProps?.isExternal,
  })
  const { products, selectedProduct } = useFlyOutProductsBasedOnSelectedCloud()
  const product =
    products.find(product => product.productId === selectedProduct) ||
    ({} as Product)
  const defaultTabs = [
    {
      key: 'private-offers',
      label: 'Private offers',
      search: `${privateOfferResaleAuthorizationTabsProps.search || ''}`,
      path: 'private-offers',
      renderElement: privateOfferResaleAuthorizationTabsProps.privateOfferComp,
    },
    ...(isResaleProduct(product) ||
    (isEmpty(product.productType) &&
      privateOfferResaleAuthorizationTabsProps?.isExternal)
      ? [
          {
            key: 'resale-authorizations',
            label: 'Reseller authorizations',
            search: `${privateOfferResaleAuthorizationTabsProps.search || ''}`,
            path: 'resale-authorizations',
            renderElement:
              privateOfferResaleAuthorizationTabsProps.resaleOfferComp ? (
                privateOfferResaleAuthorizationTabsProps.resaleOfferComp
              ) : (
                <></>
              ),
          },
        ]
      : []),
  ]

  const {
    defaultSettingsTabs,
    activeTab,
    handleTabChange,
    settingsTabsForRouting,
  } = settingsTabs([], defaultTabs, true)

  return (
    <div
      data-testid="labra-private-offer-resale-authorization-tab"
      className={clsx(
        classes.revamp,
        privateOfferResaleAuthorizationTabsProps?.tableEl ? classes.scroll : ''
      )}
      ref={privateOfferResaleAuthorizationTabsProps?.tableEl}
    >
      <MainTabsV2
        tabs={defaultSettingsTabs}
        activeTabIndex={activeTab}
        onChange={handleTabChange}
        tabsType={'main'}
      />

      <Suspense fallback={<div />}>
        <Routes>
          {settingsTabsForRouting.map(t => {
            return (
              <Route
                key={t.path}
                path={t.path}
                element={t.renderElement ? t.renderElement : <></>}
              />
            )
          })}
        </Routes>
      </Suspense>
    </div>
  )
}
export default PrivateOfferResaleAuthorizationTabs
